<template>
    <transition name="fade">
        <div v-if="render" class="modal">
            <div class="modal__backdrop" @click="requestClose"></div>
            <div class="modal__dialog">
                <div class="modal__header">
                    <slot name="header"></slot>
                </div>

                <div class="modal__body">
                    <slot name="body"></slot>
                </div>

                <div class="modal__footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "Modal",
        props: {
            show: {
                type: Boolean,
                default: null,
            },
            value: Boolean,
            close: {
                type: Function,
            },
        },

        computed: {
            render() {
                if (this.show == null) {
                    return this.value
                } else {
                    return this.show
                }
            },
        },

        methods: {
            requestClose() {
                if (this.close) {
                    this.$emit("input", false)
                    this.$emit("close")
                    this.close()
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .modal {
        font-family: MessinaSansWeb, serif;
        overflow-x: hidden;
        overflow-y: auto;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9;
        &.wide {
            .modal__dialog {
                background-color: #ffffff;
                position: relative;
                width: 766px;
                margin: 50px auto;
                display: flex;
                flex-direction: column;
                border-radius: 8px;
                z-index: 2;
                -webkit-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);
                -moz-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);
                box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);
                @media screen and (max-width: 992px) {
                    width: 90%;
                }
            }
        }
        &__backdrop {
            background-color: rgba(0, 0, 0, 0.3);
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1;
        }
        &__dialog {
            background-color: #ffffff;
            position: relative;
            width: 600px;
            margin: 50px auto;
            display: flex;
            flex-direction: column;
            border-radius: 8px;
            z-index: 2;
            -webkit-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);
            -moz-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);
            box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);
            @media screen and (max-width: 992px) {
                width: 90%;
            }
        }
        &__header {
            padding: 10px 20px 0px 20px;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
        }
        &__body {
            padding: 10px 20px 20px 20px;
            overflow: auto;
            display: flex;
            flex-direction: column;
            align-items: stretch;
        }
        &__footer {
            padding: 10px 20px 20px;
        }
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
